// Folder creation
export const FOLDER_CREATE_REQUEST = 'FOLDER_CREATE_REQUEST';
export const FOLDER_CREATE_SUCCESS = 'FOLDER_CREATE_SUCCESS';
export const FOLDER_CREATE_FAIL = 'FOLDER_CREATE_FAIL';
export const FOLDER_CREATE_RESET = 'FOLDER_CREATE_RESET';

// Folder list
export const FOLDER_LIST_REQUEST = 'FOLDER_LIST_REQUEST';
export const FOLDER_LIST_SUCCESS = 'FOLDER_LIST_SUCCESS';
export const FOLDER_LIST_FAIL = 'FOLDER_LIST_FAIL';

// Folders by owner
export const FOLDER_BY_OWNER_REQUEST = 'FOLDER_BY_OWNER_REQUEST';
export const FOLDER_BY_OWNER_SUCCESS = 'FOLDER_BY_OWNER_SUCCESS';
export const FOLDER_BY_OWNER_FAIL = 'FOLDER_BY_OWNER_FAIL';

// Folder update
export const FOLDER_UPDATE_REQUEST = 'FOLDER_UPDATE_REQUEST';
export const FOLDER_UPDATE_SUCCESS = 'FOLDER_UPDATE_SUCCESS';
export const FOLDER_UPDATE_FAIL = 'FOLDER_UPDATE_FAIL';
export const FOLDER_UPDATE_RESET = 'FOLDER_UPDATE_RESET';

// Folder delete
export const FOLDER_DELETE_REQUEST = 'FOLDER_DELETE_REQUEST';
export const FOLDER_DELETE_SUCCESS = 'FOLDER_DELETE_SUCCESS';
export const FOLDER_DELETE_FAIL = 'FOLDER_DELETE_FAIL';

// Initialize default folders
export const FOLDER_INITIALIZE_REQUEST = 'FOLDER_INITIALIZE_REQUEST';
export const FOLDER_INITIALIZE_SUCCESS = 'FOLDER_INITIALIZE_SUCCESS';
export const FOLDER_INITIALIZE_FAIL = 'FOLDER_INITIALIZE_FAIL';

// Reorder folders
export const FOLDER_REORDER_REQUEST = 'FOLDER_REORDER_REQUEST';
export const FOLDER_REORDER_SUCCESS = 'FOLDER_REORDER_SUCCESS';
export const FOLDER_REORDER_FAIL = 'FOLDER_REORDER_FAIL';
export const FOLDER_REORDER_RESET = 'FOLDER_REORDER_RESET';
